<template>
  <div class="box" @click="showDetail(news)">
    <div class="box_item title">{{ news.title }}</div>
    <div class="box_flex box_item">
      <div class="color-gray-7">
        <i class="el-icon-watch" />{{ news.createTime }}
      </div>
      <div class="color-gray-7 ml20">
        <i class="el-icon-view" />{{ news.readCount }}阅读
      </div>
    </div>
    <div class="box_item box_item_content ellipsis">{{ news.content }}</div>
  </div>
</template>

<script>
export default {
  props: {
    news: {},
  },
  data() {
    return {};
  },
  methods: {
    showDetail(news) {
      this.$emit("showDetail", news);
    },
  },
};
</script>

<style scoped>
.box {
  border-bottom: 1px dashed #d9d9d9;
  padding-bottom: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}

.box_flex {
  display: flex;
}

.title {
  color: #262626;
  font-size: 18px !important;
  font-weight: 600;
}

.box_item {
  font-size: 16px;
  margin-top: 10px;
}

.box_item_content {
  color: #8c8c8c !important;
  margin-top: 20px;
}

.box_item_time {
  color: #8c8c8c !important;
}
.ellipsis {
  -webkit-line-clamp: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/designPage/template/components/content_item.vue